import React, { ReactNode } from 'react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/react'
import { getToken } from 'utils'
import MessageErrorDefault from '../MessageErrorDefault'

interface IErrorBoundaryProps {
  children: ReactNode
}

class ErrorBoundary extends React.Component<IErrorBoundaryProps> {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  // eslint-disable-next-line react/sort-comp
  state = {
    hasError: false,
    eventId: null,
  }

  constructor(props: IErrorBoundaryProps | Readonly<IErrorBoundaryProps>) {
    super(props)
    this.setState({ eventId: null })
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  async componentDidCatch(error: any, errorInfo: any) {
    this.setState({ hasError: true })
    const userLocal = localStorage.getItem(`_plurall_user_${getToken()}`)
    let userData = {}

    if (userLocal) {
      const user: {
        mail: string
        plurall_id: string
        somos_id: string
      } = JSON.parse(userLocal)
      userData = {
        email: user.mail,
        plurall_id: user.plurall_id,
        somos_id: user.somos_id,
        token: getToken(),
      }
    }

    Sentry.withScope((scope) => {
      scope.setExtras({
        ...errorInfo,
        user: userData,
      })
      const eventId = Sentry.captureException(error)
      this.setState({ eventId })
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <MessageErrorDefault/>
      )
    }

    return <>{this.props.children}</>
  }
}

export default ErrorBoundary
